import React from 'react';
import { FieldFactoryProps, TextFieldProps as ExtraProps } from '../types';
import BaseTextField from './BaseTextField';

type FFProps = FieldFactoryProps<string, HTMLTextAreaElement> &
    ExtraProps<HTMLTextAreaElement>;

/**
 * Displays a field as an <textarea> element.
 *
 * Supports debounce. See the `debounce` property.
 */
const TextAreaField = (props: FFProps) =>
    <BaseTextField<HTMLTextAreaElement> {...props} factory={factory} />;

const factory = ({
    className,
    elementRef,
    Renderer, error, label, onValueReset, onValueSubmit,
    onInputChange, onValueChange,
    ...props
}: FFProps) => <textarea
    className={`form-control ${className}`}
    ref={elementRef}
    {...props}
/>;

export default TextAreaField;
